import { Component, Inject, OnDestroy, OnInit, forwardRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { ReportsService } from '../../reports.service';
import { FlexModule } from '@angular/flex-layout';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';
import { ActivityChartComponent } from './activity-chart.component';
import { ActivityPieChartComponent } from './activity-pie-chart.component';
import { MatButton } from '@angular/material/button';

export interface MatActivityDashboardZoomDialogData {
  chartData: any[];
  showActivityChart: boolean;
  showActivityPieChart: boolean;
  dialogTitle: string;
  chartType: 'line' | 'bar';
  startDate: string;
  endDate: string;
}

@Component({
  selector: 'app-mat-chart-user-dialog',
  template: `
    <div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
      <mat-dialog-content class="mat-typography" fxFlex>
        <app-activity-chart [data]="data.chartData" [chartType]="data.chartType" [startDate]="data.startDate" [endDate]="data.endDate"
                            *ngIf="data.showActivityChart"></app-activity-chart>
        <app-activity-pie-chart [data]="data.chartData" *ngIf="data.showActivityPieChart"></app-activity-pie-chart>
      </mat-dialog-content>

      <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close="">Close</button>
      </mat-dialog-actions>
    </div>
  `,
  standalone: true,
  imports: [
    FlexModule,
    MatDialogContent,
    NgIf,
    forwardRef(() => ActivityChartComponent),
    forwardRef(() => ActivityPieChartComponent),
    MatDialogActions,
    MatButton,
    MatDialogClose,
  ],
})
export class MatActivityDashboardZoomDialogComponent {

  constructor(public reportsService: ReportsService,
              public dialogRef: MatDialogRef<MatActivityDashboardZoomDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: MatActivityDashboardZoomDialogData,
  ) {
  }
}
